import { useTranslation } from 'react-i18next'
import { Modal } from '~/shared/ui/Modal'
import { Title, Description, Ul, LI, Question } from './styled'

type NotCompleteSetModalProps = {
  isShow: boolean
  onCancel: () => void
  onOk: () => void
  values?: string[]
}

export function NotCompleteSetModal({
  isShow,
  onCancel,
  onOk,
  values,
}: NotCompleteSetModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isShow={isShow}
      onCancel={onCancel}
      onOk={onOk}
      cancel={t('button.no')}
      ok={t('button.yes')}
      reverseButton
    >
      <Title>{t('incomplete equipment')}</Title>
      <Description>
        {t('missing equipment detected during this inspection')}
      </Description>

      <Ul>
        {values?.map((value) => (
          <LI key={value}>{value}</LI>
        ))}
      </Ul>
      <Question>{t('do you want to continue?')}</Question>
    </Modal>
  )
}
